import { NavLink, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useCart } from "@/contexts/CartContext";
import { ShoppingCart, User, List, X } from "@phosphor-icons/react";
import { useState } from "react";
import MiniCartDrawer from "@/components/MiniCartDrawer";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/shop", label: "Shop" },
  { to: "/dosage-calculator", label: "Calculator" },
  { to: "/partners", label: "Partners" },
  { to: "/about", label: "About" },
];

export default function Navbar() {
  const { user } = useAuth();
  const { count } = useCart();
  const [open, setOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);

  const accountHref = user && user !== false
    ? (user.role === "admin" ? "/admin" : user.role === "affiliate" ? "/affiliate" : "/account")
    : "/login";

  return (
    <>
      <header className="sticky top-0 z-40 nav-blur">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
            <span className="font-display text-3xl tracking-tight leading-none select-none">
              <span className="text-white">PRM</span>
              <span className="accent-slash">U</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to={accountHref}
              className="hidden md:inline-flex items-center gap-2 btn-ghost"
              data-testid="nav-account"
            >
              <User size={16} weight="regular" />
              <span>{user && user !== false ? user.name?.split(" ")[0] || "Account" : "Sign in"}</span>
            </Link>
            <button
              onClick={() => setCartOpen(true)}
              className="relative inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white text-black hover:bg-blue-500 hover:text-white transition-colors font-semibold text-sm"
              data-testid="nav-cart"
              aria-label="Open cart"
            >
              <ShoppingCart size={16} weight="bold" />
              <span className="font-mono text-xs" data-testid="cart-count">{count}</span>
              {count > 0 && (
                <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-blue-500 ring-2 ring-black" />
              )}
            </button>
            <button
              className="lg:hidden p-2 rounded-full border border-white/10 hover:border-white/40"
              onClick={() => setOpen((o) => !o)}
              aria-label="Toggle menu"
              data-testid="nav-toggle"
            >
              {open ? <X size={18} /> : <List size={18} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden border-t border-white/10">
            <div className="mx-auto max-w-[1400px] px-6 py-4 flex flex-col gap-3">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.end}
                  onClick={() => setOpen(false)}
                  data-testid={`mnav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={({ isActive }) => `text-base ${isActive ? "text-blue-500 font-semibold" : ""}`}
                >
                  {n.label}
                </NavLink>
              ))}
              <Link
                to={accountHref}
                onClick={() => setOpen(false)}
                className="text-base border-t border-white/10 pt-3"
                data-testid="mnav-account"
              >
                {user && user !== false ? "My Account" : "Sign in"}
              </Link>
            </div>
          </div>
        )}
      </header>

      <MiniCartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
    </>
  );
}
